import { resolveSessionParentPathForAgentProcess } from '../../../../paths/session-layout-paths.js';
import type { MessageHandlerDeps } from '../../../../routing/message-handler-deps.js';
import type { ApiToBridgePromptMessage } from '../../../../types/api-to-bridge-messages.js';
import type { SessionAttachmentRef } from '../../fetch-session-attachments.js';
import { parseFollowUpFieldsFromPromptMessage, runBridgePromptPreamble } from '../bridge-prompt-preamble.js';
import type { BridgePromptSenders } from '../bridge-prompt-wiring.js';

export async function runPreambleAndPrompt(params: {
  deps: MessageHandlerDeps;
  msg: ApiToBridgePromptMessage;
  getWs: MessageHandlerDeps['getWs'];
  log: MessageHandlerDeps['log'];
  sessionWorktreeManager: MessageHandlerDeps['sessionWorktreeManager'];
  sessionId: string | undefined;
  runId: string | undefined;
  promptText: string;
  attachments: SessionAttachmentRef[];
  mode: string | undefined;
  agentType: string | undefined;
  agentId: string | null;
  agentConfig: Record<string, unknown> | undefined;
  resolvedCwd: string | undefined;
  senders: BridgePromptSenders;
}): Promise<void> {
  const {
    deps,
    msg,
    getWs,
    log,
    sessionWorktreeManager,
    sessionId,
    runId,
    promptText,
    attachments,
    mode,
    agentType,
    agentId,
    agentConfig,
    resolvedCwd,
    senders: { sendResult, sendSessionUpdate },
  } = params;
  const effectiveCwd = resolveSessionParentPathForAgentProcess(resolvedCwd);
  await runBridgePromptPreamble({
    getWs,
    log,
    sessionWorktreeManager,
    sessionId,
    runId,
    effectiveCwd,
  });

  const { followUpCatalogPromptId } = parseFollowUpFieldsFromPromptMessage(msg);

  deps.acpManager.handlePrompt({
    promptText,
    promptId: msg.id as string | undefined,
    sessionId,
    runId,
    mode,
    agentType,
    agentId,
    agentConfig,
    sessionParentPath: effectiveCwd,
    sendResult,
    sendSessionUpdate,
    followUpCatalogPromptId,
    cloudApiBaseUrl: deps.cloudApiBaseUrl,
    getCloudAccessToken: deps.getCloudAccessToken,
    e2ee: deps.e2ee,
    ...(attachments.length > 0 ? { attachments } : {}),
    isNewSession: msg.isNewSession === true,
  });
}
